module.exports = __webpack_public_path__ + "static/media/tencel.e43970f5.jpg";